import React from 'react';
import { Button } from '../ui/Button';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  const scrollToCTA = () => {
    document.getElementById('cta-section')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative bg-gradient-to-b from-blue-50 to-white pt-16 pb-20 lg:pt-24 lg:pb-28 overflow-hidden" data-id="element-66">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-67">
        <div className="text-center max-w-4xl mx-auto mb-12" data-id="element-68">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-extrabold text-slate-900 tracking-tight mb-6 leading-tight" data-id="element-69">
            Guía Anti-Sofocos Nocturnos <br className="hidden sm:block" data-id="element-70" />
            <span className="text-teal-600" data-id="element-71">en 7 Días</span>
          </h1>
          <h2 className="text-xl sm:text-2xl text-slate-600 font-medium max-w-2xl mx-auto mb-8 leading-relaxed" data-id="element-72">
            Elimina los sofocos que te despiertan empapada a las 3AM, sin
            hormonas ni pastillas.
          </h2>
          <Button onClick={scrollToCTA} size="lg" className="w-full sm:w-auto group" data-id="element-73">
            Quiero Dormir Toda la Noche
            <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-74" />
          </Button>
        </div>

        <div className="relative max-w-5xl mx-auto mt-12" data-id="element-75">
          <div className="absolute inset-0 bg-teal-200 blur-3xl opacity-20 rounded-full transform scale-90 translate-y-10" data-id="element-76"></div>
          <img src="https://cdn.magicpatterns.com/uploads/rxdqEvdDwDWfgLNjeDfj3F/mockup-of-a-digital-ebook.png" alt="Mockup de la Guía Digital en tablet sobre mesa de noche" className="relative z-10 w-full h-auto rounded-xl shadow-2xl border border-slate-100 transform hover:scale-[1.01] transition-transform duration-500" data-id="element-77" />
        </div>
      </div>
    </section>;
}